module.exports = __webpack_public_path__ + "static/media/forest-bg.593af7c5.jpg";